import React, { useState } from 'react';
import './App.css';
import TaskForm from './components/TaskForm';
import TaskList from './components/TaskList';

function App() {
    // Estado para almacenar la lista de tareas
    const [tasks, setTasks] = useState([
        { id: 1, text: 'Comprar pan', completed: false, dueDate: null },
        { id: 2, text: 'Terminar informe', completed: true, dueDate: new Date().toISOString() },
    ]);

    // Modificamos la función para recibir directamente el 'texto' de la tarea desde TaskForm
    const handleAddTask = (text) => {
        const task = {
            id: Date.now(),
            text: text,
            completed: false,
            dueDate: null, // Nuevo campo
        };
        setTasks([...tasks, task]);
    };

    const handleToggleComplete = (taskId) => {
        setTasks(
            tasks.map((task) =>
                task.id === taskId ? { ...task, completed: !task.completed } : task
            )
        );
    };

    const handleDeleteTask = (taskId) => {
        setTasks(tasks.filter((task) => task.id !== taskId));
    };

    // NUEVA FUNCIÓN para actualizar sólo la fecha
    const handleUpdateTaskDate = (taskId, newDate) => {
        setTasks(
            tasks.map((task) =>
                task.id === taskId ? { ...task, dueDate: newDate ? newDate.toISOString() : null } : task
            )
        );
    };

    return (
        <div className="app-container">
            <div className="todo-container">
                <h1>Mi Lista de Tareas</h1>

                {/* Uso del nuevo componente TaskForm, pasando la función de callback */}
                <TaskForm onAddTask={handleAddTask} />

                {/* Habrá que pasar handleUpdateTaskDate al TaskList y de allí al TaskItem */}
                <TaskList
                    tasks={tasks}
                    onToggleComplete={handleToggleComplete}
                    onDeleteTask={handleDeleteTask}
                    onUpdateTaskDate={handleUpdateTaskDate} // Nueva 'prop'
                />
            </div>
        </div>
    );
}

export default App;